export type LogoutRedirectTarget =
  | string
  | {
      pathname: string;
      query?: Record<string, string | number | boolean | null | undefined>;
    };

let pendingLogoutRedirectTarget: LogoutRedirectTarget | null = null;

export function setPendingLogoutRedirectTarget(target: LogoutRedirectTarget) {
  pendingLogoutRedirectTarget = target;
}

export function hasPendingLogoutRedirectTarget(): boolean {
  return pendingLogoutRedirectTarget !== null;
}

export function consumePendingLogoutRedirectTarget(): LogoutRedirectTarget | null {
  const target = pendingLogoutRedirectTarget;
  pendingLogoutRedirectTarget = null;
  return target;
}

export function clearPendingLogoutRedirectTarget() {
  pendingLogoutRedirectTarget = null;
}
